/**
 * Reports list
 */
function irReportsListPage() {
	if (!document.querySelector('main.subpage.ir-page.reports-list')) return;

	/**
	 * @typedef {{
	 *  rok?: string,
	 *  'slowo-kluczowe'?: string
	 *  'data-poczatkowa'?: string,
	 *  'data-koncowa'?: string
	 * }} FilterState
	 */

	const detailsForm = /** @type {HTMLFormElement} */document.querySelector('form.detailed-filter');
	const yearsForm = /** @type {HTMLFormElement} */ document.querySelector('form.years-filter');
	const table = /** @type {HTMLTableElement} */document.querySelector('table.reports-table');
	const tableRows = /*** @type {NodeListOf<HTMLTableRowElement>}*/table.querySelectorAll('tbody tr:not(.empty-row)');
	const emptyRow = document.querySelector('table.reports-table tbody tr.empty-row');

	const getDetailsFormData = () => new FormData(detailsForm);
	const getYearsFormData = () => new FormData(yearsForm);

	/**
	 * @param {'year' | 'details'} priority
	 * @return {FilterState}
	 */
	const getFilterValues = (priority = 'year') => {
		const priorityDetails = priority === 'details';

		return /** @type {FilterState}*/{
			rok: priorityDetails ? undefined : getYearsFormData().get('rok'),
			'slowo-kluczowe': priorityDetails ? getDetailsFormData().get('slowo-kluczowe') : undefined,
			'data-poczatkowa': priorityDetails ? getDetailsFormData().get('data-poczatkowa') : undefined,
			'data-koncowa': priorityDetails ? getDetailsFormData().get('data-koncowa') : undefined,
		};
	};

	const hasDetailsFormValues = Array.from(getDetailsFormData().values()).some(Boolean) ? 'details' : 'year';
	const filters = /** @type {ReactiveTuple<FilterState>} */ reactive(
		getFilterValues(hasDetailsFormValues),
	);

	if (yearsForm) {
		const years = /** @type NodeListOf<HTMLInputElement>*/ yearsForm.querySelectorAll('[name="rok"]');
		for (const yearInput of years) {
			yearInput.addEventListener('change', () => {
				filters.set(getFilterValues('year'));
			});
		}
	}

	if (detailsForm) {
		detailsForm.addEventListener('submit', (event) => {
			event.preventDefault();

			// Update filters state based on details filters form
			filters.set(getFilterValues('details'));
		});
	}

	/**
	 * @param {FilterState} filters
	 */
	function updateFiltersView(filters) {
		let activeItemsCounter = 0;
		if (filters.rok) {
			// Clear details form inputs
			if (detailsForm) {
				for (const input of detailsForm.querySelectorAll('input')) {
					input.value = '';
				}
			}

			// Filter view
			for (const tr of tableRows) {
				const isActive = tr.dataset.year === filters.rok;
				tr.dataset.active = isActive ? 'true' : 'false';
				activeItemsCounter += isActive ? 1 : 0;
			}

		} else {
			// Uncheck all radio from years filter
			if (yearsForm) {
				const years = /** @type NodeListOf<HTMLInputElement>*/ yearsForm.querySelectorAll('[name="rok"]');
				for (const yearInput of years) {
					yearInput.checked = false;
				}
			}

			// Filter view
			for (const tr of tableRows) {
				const matches = /** @type {boolean[]}*/[];
				const trContent = tr.innerText;
				const keyword = filters?.['slowo-kluczowe'] ?? null;
				if (!!keyword && keyword.trim().length > 0 && trContent.trim().length > 0) {
					matches.push(trContent.trim().toLowerCase().includes(keyword.trim().toLowerCase()));
				}

				if (tr.dataset?.date) {
					const rowDate = dayjs(tr.dataset.date, 'YYYY-mm-dd');
					const filterDateFrom = filters?.['data-poczatkowa'] ? dayjs(filters['data-poczatkowa'], 'YYYY-mm-dd') : null;
					const filterDateTo = filters?.['data-koncowa'] ? dayjs(filters['data-koncowa'], 'YYYY-mm-dd') : null;

					if (!!filterDateFrom) {
						matches.push(rowDate.isSame(filterDateFrom) || rowDate.isAfter(filterDateFrom));
					}

					if (!!filterDateTo) {
						matches.push(rowDate.isSame(filterDateTo) || rowDate.isBefore(filterDateTo));
					}
				}

				// `[].every(Boolean)` is true, but passed additional check to make code cleaner
				const isActive = matches.length === 0 || matches.every(Boolean);
				tr.dataset.active = isActive ? 'true' : 'false';
				activeItemsCounter += isActive ? 1 : 0;
			}
		}

		const hasData = activeItemsCounter > 0;

		emptyRow.dataset.active = !hasData ? 'true' : 'false';
		table.dataset.empty = !hasData ? 'true' : 'false';

		// update query params
		const url = new URL(location.href);
		for (const [key, value] of Object.entries(filters)) {
			if (value) {
				url.searchParams.set(key, String(value));
			} else {
				url.searchParams.delete(key);
			}
		}

		history.replaceState(null, '', url);
	}

	filters.subscribe(updateFiltersView);
}
